import { render, staticRenderFns } from "./AssociateAssistLicense.vue?vue&type=template&id=9a21963c&"
import script from "./AssociateAssistLicense.vue?vue&type=script&lang=js&"
export * from "./AssociateAssistLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports